import { put, takeLatest, delay } from "redux-saga/effects";
import { checkRegisterDeviceApi } from "store/api/LoginApi";
import { CHECK_REGISTER_DEVICE_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* checkRegisterDevice(action) {
	const { data, onSuccess } = action.params;

	const res = yield checkRegisterDeviceApi(data);
	try {
		if (res?.code === 0) {
			onSuccess(
				res?.data?.statusRegisterDevice,
				res?.data?.urlUserRegisterDevice
			);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	}
}

function* checkRegisterDeviceSaga() {
	yield takeLatest(CHECK_REGISTER_DEVICE_ACTION, checkRegisterDevice);
}

export default checkRegisterDeviceSaga;
